var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-Progress"},[_c('ul',_vm._l((_vm.tunnelListData),function(item){return _c('li',{key:item.id},[_c('div',{staticClass:"province-title"},[_c('p',[_vm._v(_vm._s(_vm.processVariableName(item.name)))]),_c('p',[_c('el-progress',{attrs:{"percentage":Number(item.num),"stroke-width":15,"color":"#58DEFF"}})],1)])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }